module.exports = __webpack_public_path__ + "static/media/mute.497d2ff5.png";